module.exports = __webpack_public_path__ + "img/10.4a14fb78.jpeg";